/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A single transaction in the wallet response
 * @export
 * @interface WalletTransactionItem
 */
export interface WalletTransactionItem {
    /**
     * 
     * @type {string}
     * @memberof WalletTransactionItem
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WalletTransactionItem
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof WalletTransactionItem
     */
    subject?: string;
    /**
     * 
     * @type {number}
     * @memberof WalletTransactionItem
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof WalletTransactionItem
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof WalletTransactionItem
     */
    tournamentId?: string;
    /**
     * 
     * @type {string}
     * @memberof WalletTransactionItem
     */
    tournamentName?: string;
    /**
     * 
     * @type {number}
     * @memberof WalletTransactionItem
     */
    createdAt?: number;
}

/**
 * Check if a given object implements the WalletTransactionItem interface.
 */
export function instanceOfWalletTransactionItem(value: object): value is WalletTransactionItem {
    return true;
}

export function WalletTransactionItemFromJSON(json: any): WalletTransactionItem {
    return WalletTransactionItemFromJSONTyped(json, false);
}

export function WalletTransactionItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): WalletTransactionItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'subject': json['subject'] == null ? undefined : json['subject'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'tournamentId': json['tournamentId'] == null ? undefined : json['tournamentId'],
        'tournamentName': json['tournamentName'] == null ? undefined : json['tournamentName'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
    };
}

export function WalletTransactionItemToJSON(json: any): WalletTransactionItem {
    return WalletTransactionItemToJSONTyped(json, false);
}

export function WalletTransactionItemToJSONTyped(value?: WalletTransactionItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'subject': value['subject'],
        'amount': value['amount'],
        'notes': value['notes'],
        'tournamentId': value['tournamentId'],
        'tournamentName': value['tournamentName'],
        'createdAt': value['createdAt'],
    };
}

